import { useEffect, useState } from "react";
import MercadoPagoPayment from "./MercadoPagoPayment";
import api from "../utils/api";



export function TestingPayment() {

    const amount = 10000; // Monto a pagar
    const payer = {};

    // Generar la preferencia de pago al montar el componente
    const [preferenceId, setPreferenceId] = useState(null);
    const [externalReference, setExternalReference] = useState(null);
    

    const fetchData = async () => {
        try {
            const response = await api.post("registrar-verificacion-antecedentes", {
                nombreVerificar : "", apellidosVerificar: "",
                tipoPersonaVerificar: "natural",
                tipoDocumentoVerificar: "CC",
                cedulaVerificar: "7661814", tipoPersona: "natural",
                razonSocial: "",
                tipoDocumentoFacturacion: "CC",
                nombreComprador: "samuel",
                apellidosComprador: "trias",
                documentoFacturacion: "7661814",
                whatsappComprador: "3143663831",
                emailComprador: "samuel@prestanza.com",
                acceptTerms: true
            });
            
            const data = await response.data;

            setPreferenceId(data.preference_id);
            setExternalReference(data.external_reference);
        } catch (error) {
            console.error("Error al generar la preferencia de pago:", error);
        }
    }
    
    useEffect(() => {
        fetchData();
    }, []);

    return (
    <div className="p-8 max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Prueba de Integración Mercado Pago</h1>
      
      {!preferenceId ? (
          <div className="flex flex-col items-center justify-center p-12 bg-white rounded-2xl border border-gray-100 shadow-sm">
              <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-emerald-600 mb-4"></div>
              <p className="text-gray-500 font-medium">Generando preferencia de pago...</p>
          </div>
      ) : (
          <MercadoPagoPayment 
            amount={amount} 
            preferenceId={preferenceId} 
            payer={payer} 
            externalReference={externalReference} 
            onPaymentSuccess={(paymentId) => {
                console.log("Pago exitoso:", paymentId);
                alert("¡Pago realizado con éxito! ID: " + paymentId);
            }} 
          />
      )}
    </div>
  )
}